import { parseHtml } from '@frontend/libs/utils'

function PageTitle({ title }: Readonly<{ title: string }>) {
  return (
    <div className="mb-10 text-center">
      <h1 className="text-2xl font-medium uppercase text-primary">
        {parseHtml(title)}
      </h1>
    </div>
  )
}

export default PageTitle
